const Badge = (props)=>{
    const {className = ''} = props;
    return(
        <span className = {'badge ' + className} >
            {props.children}
        </span>
    )
};
export default Badge;